import { cn } from '@/lib/utils';

// Single source of truth for the floating-composer dock geometry shared by the
// message composer and the event composer. The `24rem` right offset mirrors the
// Speak2Me panel width (`w-96`); keep it here so there is exactly one copy.
export function composerContainerClassName(neoOpen: boolean): string {
  return cn(
    'pointer-events-auto fixed z-50 flex flex-col border bg-background shadow-2xl',
    'inset-x-0 bottom-0 w-full rounded-t-lg md:inset-x-auto md:w-[30rem] md:max-w-[calc(100vw-3rem)] md:rounded-lg',
    // NeoChat closed → the composer is an in-flow item in the bottom-right dock (the Speak2Me
    // button stacks above it). NeoChat open → it stays pinned, docked left of the panel.
    neoOpen ? 'md:bottom-6 md:right-[calc(24rem+1rem)]' : 'md:static'
  );
}
